import React, { ReactNode } from "react";
import { _LandingFooterRoot } from "../LandingFooter.styled";
import Typography from "../../../../Foundation/Typography/Typography";
import FlexBox from "../../../FlexBox/FlexBox";
import Link from "../../../../Core/Link/Link";
import { IconName } from "../../../../lib/svgIcon/components";
import { useHighlightedTypographyContext } from "../../../HighlightedTypography/HighlightedTypography.context";
import htmlParse from "html-react-parser";
import MargauxMotinLogo from "../../../MargauxMotinLogo/MargauxMotinLogo";
import StyledDiv from "../../../StyledDiv/StyledDiv";

interface IFooterMargauxMotinProps {
  logoLink?: string;
  title: string;
  hashtag?: string;
  socialNetworkLabel?: string;

  onClick?: () => void;
  socialLinks?: {
    facebook?: string;
    instagram?: string;
    twitter?: string;
    tiktok?: string;
    pinterest?: string;
  };

  footerText?: string;
}
const socialIcon: Record<
  keyof NonNullable<IFooterMargauxMotinProps["socialLinks"]>,
  IconName | ((color: string) => ReactNode)
> = {
  facebook: (color = "#1B1A16") => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.75231 0C1.23897 0 0 1.23683 0 2.75018V19.2527C0 20.7639 1.23897 22 2.75231 22H11.1045V14.1106H8.46733V10.6759H11.1045V8.95496C11.1045 6.30074 13.0664 4.22087 15.5713 4.22087H18.0016V8.1041H15.8272C15.2571 8.1041 15.0901 8.42895 15.0901 8.8789V10.6759H18.0016V14.1106H15.0901V22H19.2676C20.7809 22 22.0199 20.7639 22.0199 19.2527V2.75018C22.0199 1.23683 20.7809 0 19.2676 0H2.75231Z"
        fill={color}
      />
    </svg>
  ),
  instagram: "instagram",
  twitter: (color = "#1B1A16") => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="22"
      viewBox="0 0 31 22"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.6415 9.83564C28.3234 9.69618 29.4639 8.91989 29.9062 7.8585C29.2988 8.23734 27.4116 8.65493 26.368 8.25904C26.3192 8.01112 26.2642 7.77482 26.2068 7.56022C25.4089 4.59606 22.6918 2.21218 19.8454 2.50116C20.0755 2.40974 20.3087 2.31367 20.5427 2.23775C20.8557 2.12308 22.698 1.81861 22.4075 1.15776C22.1619 0.584447 19.9159 1.59936 19.4921 1.72952C20.0484 1.51956 20.975 1.15466 21.0734 0.5C20.2158 0.620085 19.3759 1.02605 18.7275 1.63267C18.9607 1.37081 19.1396 1.06401 19.1761 0.720801C16.8944 2.20366 15.5611 5.19493 14.4835 8.09402C13.6359 7.2542 12.8828 6.60032 12.2104 6.23464C10.32 5.20268 8.06007 4.13276 4.5133 2.79478C4.40406 3.98246 5.09125 5.57146 7.07769 6.62356C6.64848 6.56778 5.86213 6.69406 5.23226 6.84746C5.48793 8.2172 6.3262 9.34213 8.59232 9.8829C7.55649 9.95185 7.02424 10.1928 6.53693 10.7103C7.00874 11.6586 8.16078 12.7804 10.2317 12.5503C7.93068 13.5583 9.29345 15.4254 11.1645 15.1465C7.97252 18.5011 2.93128 18.2517 0.0383911 15.4479C7.5898 25.9046 24.0104 21.6381 26.4586 11.5625C28.2924 11.5773 29.3693 10.9164 30.0403 10.1835C28.982 10.3702 27.4495 10.1788 26.6415 9.83564Z"
        fill={color}
      />
    </svg>
  ),
  tiktok: (color = "#1B1A16") => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
    >
      <path
        d="M10.0806 0.0185635C11.2803 0 12.4732 0.0110006 13.6647 0C13.7369 1.40326 14.2415 2.83265 15.2687 3.82477C16.2938 4.84163 17.7438 5.3071 19.1547 5.46454V9.15593C17.8325 9.11261 16.5042 8.8376 15.3045 8.26832C14.7819 8.0318 14.2952 7.72722 13.8187 7.41577C13.8125 10.0944 13.8297 12.7696 13.8015 15.4373C13.73 16.7188 13.3072 17.9942 12.5619 19.0503C11.3628 20.8083 9.28164 21.9544 7.14409 21.9902C5.83296 22.0651 4.5232 21.7076 3.40595 21.0489C1.55442 19.9571 0.251535 17.9585 0.061775 15.8133C0.0397738 15.3548 0.0322109 14.8969 0.0507744 14.4493C0.215783 12.705 1.07864 11.0363 2.41796 9.90122C3.93604 8.57908 6.06259 7.9493 8.0537 8.32194C8.07226 9.67983 8.01795 11.0363 8.01795 12.3942C7.10834 12.1 6.04541 12.1825 5.25061 12.7346C4.67033 13.1106 4.22962 13.6868 3.99998 14.3386C3.81023 14.8034 3.86454 15.3197 3.87554 15.8133C4.09349 17.3177 5.54007 18.5821 7.08427 18.4452C8.10802 18.4342 9.08913 17.8402 9.62266 16.9705C9.79523 16.6659 9.98843 16.3544 9.99874 15.9962C10.0888 14.3565 10.0531 12.7236 10.0641 11.0838C10.0716 7.38827 10.0531 3.70307 10.0812 0.019251L10.0806 0.0185635Z"
        fill={color}
      />
    </svg>
  ),
  pinterest: (color = "#1B1A16") => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.1256 10.9982C15.1256 8.73802 13.2925 6.90641 11.0295 6.90641C8.76645 6.90641 6.93341 8.73802 6.93341 10.9982C6.93341 13.262 8.76645 15.0915 11.0295 15.0915C13.2925 15.0915 15.1256 13.262 15.1256 10.9982ZM20.2807 4.24534C20.2807 4.58579 20.0042 4.86014 19.6652 4.86014H17.8215C17.4853 4.86014 17.2088 4.58579 17.2088 4.24534V2.40519C17.2088 2.06616 17.4853 1.7911 17.8215 1.7911H19.6652C20.0042 1.7911 20.2807 2.06616 20.2807 2.40519V4.24534ZM18.5983 0H3.45995C1.55939 0 0.0198975 1.53878 0.0198975 3.4365V7.16228H5.59293C6.79908 5.46286 8.78351 4.34911 11.0295 4.34911C13.2748 4.34911 15.2599 5.46286 16.4653 7.16228H22.0384V3.4365C22.0384 1.53878 20.4989 0 18.5983 0ZM17.6871 10.9982C17.6871 14.6735 14.7048 17.6509 11.0295 17.6509C7.35205 17.6509 4.37256 14.6735 4.37256 10.9982C4.37256 10.564 4.41449 10.1325 4.49623 9.71886H0.0198975V18.5649C0.0198975 20.4605 1.55939 22 3.45995 22H18.5983C20.4989 22 22.0384 20.4605 22.0384 18.5649V9.71886H17.562C17.6438 10.1325 17.6871 10.564 17.6871 10.9982Z"
        fill={color}
      />
    </svg>
  ),
};

const FooterMargauxMotin = (props: IFooterMargauxMotinProps) => {
  const { title, hashtag, socialNetworkLabel, socialLinks, footerText } = props;
  const { highlightedColor: highlightedColorContext } =
    useHighlightedTypographyContext();

  return (
    <StyledDiv
      as={_LandingFooterRoot}
      styles={{
        paddingTop: 0,
        mobile: {
          padding: "40px 16px 82px",
        },
      }}
    >
      <FlexBox direction="column" justify="center" align="center">
        <StyledDiv
          as={MargauxMotinLogo}
          className="landing-footer-logo"
          styles={{
            marginBottom: 13,
          }}
        />
        <FlexBox direction="column" justify="center" align="center" gap={20}>
          <Typography variant="h7" className="landing-footer-social-label">
            {socialNetworkLabel}
          </Typography>
          {socialLinks && (
            <FlexBox gap={16} align="center">
              {Object.entries(socialLinks)
                .filter(([, v]) => !!v)
                .map(([key, value]) => {
                  const iconName = socialIcon[key as keyof typeof socialIcon];
                  return (
                    <StyledDiv
                      as={Link}
                      key={key}
                      href={value}
                      url={value}
                      to={value}
                      icon={iconName}
                      target="_blank"
                      label=""
                      color={() => highlightedColorContext || "black"}
                      styles={{
                        maxHeight: 22,
                      }}
                    />
                  );
                })}
            </FlexBox>
          )}
        </FlexBox>

        <StyledDiv
          as={Typography}
          variant="subtitle3"
          className="landing-footer-bottom-text"
          styles={{
            marginTop: 55,
            mobile: {
              marginTop: 36,
            },
            b: {
              marginBottom: 6,
              display: "inline-block",
            },
          }}
        >
          {htmlParse(footerText + "")}
        </StyledDiv>
      </FlexBox>
    </StyledDiv>
  );
};

export default FooterMargauxMotin;
